import React, {useState} from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import format from "date-fns/format";
import { API } from "../../api-service";
import { AdminStatus } from "../statuses";

export default function Upload(props){

    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null);

    const fileChanged = evt => {
        setFile(evt.target.files[0]);
        //console.log(evt.target.files[0]);
    }

    const confirmClicked = () => {
        if(file){
            API.uploadReport(props.cases[props.caseIndex].reference_no, file, format(new Date(), "yyyy-MM-dd"), AdminStatus.completed.key, AdminStatus.completed.key, message, props.token)
            .then(alert("Upload Successful"));
            props.onHide();
            setFile(null);
            setMessage("");
        }
        else{
            alert("Please select a file");
        }
    }
    
    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Case {props.cases[props.caseIndex].reference_no} 
                    
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr",
                gridTemplateRows: "1fr",
                gridGap: "20px",
            }}>
                <input type="file" name="myfile" id="form-control" onChange={fileChanged}/>    
                <span/>
                <textarea style={{height:'100px', marginLeft:'20px'}}onChange={(text) => setMessage(text.target.value)} value={message} placeholder="  Additional Information"/>
                <span/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={confirmClicked}>Confirm</Button>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}